import { Component, Injector, OnInit } from '@angular/core';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';

@Component({
  selector: 'laas-user-subscribtion-permission',
  templateUrl: './user-subscribtion-permission.component.html',
  styleUrls: ['./user-subscribtion-permission.component.scss']
})
export class UserSubscribtionPermissionComponent extends SessionBaseComponent implements OnInit {
  isShowAddSubscribtion: boolean = false;
  isShowEditColumn: boolean = false;
  constructor(injector: Injector) {
    super(injector);
  }

}
